import { Directive, OnInit, Input, ElementRef, Renderer2, AfterViewInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[fadeIn]'
})
export class FadeInDirective implements OnInit, AfterViewInit {

    @Input() fadeIn: number = 100;
    @Input() transition: number = 500;
    @Input() direction: 'X' | 'Y' = 'X';
    @Input() translatePx: number = 20;

    constructor(private renderer: Renderer2, public el: ElementRef, private cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.renderer.setStyle(this.el.nativeElement, 'background', 'red !important');
        this.renderer.setStyle(this.el.nativeElement, 'opacity', '0 !important');
        this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate' + this.direction + '(' + this.translatePx + ') !important');
        this.renderer.setStyle(this.el.nativeElement, 'transition', this.transition / 1000 + 's');
        console.log("hello from fadeIn, delay: ", this.fadeIn);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            console.log("hello from fadeIn, delay: ", this.fadeIn, this.el.nativeElement);
            this.renderer.setStyle(this.el.nativeElement, 'opacity', '1  !important');
            this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate' + this.direction + '(' + this.translatePx + ') !important');
            this.cd.markForCheck();
            console.log(this.el.nativeElement);
        }, this.fadeIn)
    }

}
